import {
  Avatar, AvatarProps, ICON_CLIPBOARD_TEXT_OUTLINE,
} from '@doveit/bricks';
import React from 'react';

export type FeedbackAvatarProps = Pick<AvatarProps, 'size' | 'placeholder'>;

export const FeedbackAvatar: React.FC<FeedbackAvatarProps> = (props) => (
  <Avatar
    {...props}
    placeholder={ICON_CLIPBOARD_TEXT_OUTLINE}
  />
);

export default FeedbackAvatar;
